// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { RepInfo } from "@gcg/App/Components/RepInfo/RepInfo";
import { InvoiceStateContext } from "@insite/client-framework/Store/Data/Invoices/InvoicesSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { InvoiceDetailsPageContext } from "@insite/content-library/Pages/InvoiceDetailsPage";
import React, { FC, useContext } from "react";

const InvoiceDetailsRepInfo: FC = () => {
    const { value: invoice } = useContext(InvoiceStateContext);
    const salesPersonData = invoice && invoice.properties && invoice.properties.salesPerson;

    if (!invoice || !salesPersonData) {
        return null;
    }

    return <RepInfo salesPersonData={salesPersonData} clickable={true} />;
};

const widgetModule: WidgetModule = {
    component: InvoiceDetailsRepInfo,
    definition: {
        allowedContexts: [InvoiceDetailsPageContext],
        group: "Invoice History",
    },
};

export default widgetModule;
